import { Link, Typography } from "@material-ui/core";
import React from "react";

export function RSPCopyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="http://dunstanpediatric.com/">
        Dunstan Pediatric
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
